import './i18n';
import { initSentry } from "@repo/shared/instrument-factory";
import React from "react";

// Sentry project shared with apps/outlook (Microsoft 365 surfaces report
// to a single project). Browser tracing is on — the M365 host iframes
// tolerate it.
initSentry({
  dsn: "https://8ed42bce633329e9c9093c39fbb28e99@o4507221443936256.ingest.us.sentry.io/4510494638276608",
  tracing: { sampleRate: 1.0 },
});
import { createRoot } from "react-dom/client";

import App from "./App";
import "./index.css";


const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);